import { Component } from '@angular/core';
import { CopyService } from '../../services/copies/copy.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})

/**
 * Definición de la clase FooterComponent, clase para el comportamiento del componente footer
 *
 * *Defines FooterComponent class, footer behavior class *
 */
export class FooterComponent {

  /**
   * Summary Constructor of the component.
   *
   * @param {ChannelCommunicatorService} channel Injectable channel service.
   */
  constructor(
    public copyService: CopyService,
  ) { }
}
